import ComponentManager from "../../componentFramework";
import JsfJsCommand from "../JsfJsCommand";
import CmsInterface from "../../scripts/CmsInterface";
import UrlUtil from "../../scripts/UrlUtil";
import JsfAjax from "../../scripts/jsf/JsfAjax"
import EventListenerManager from "../EventListenerManager";

/**
 * This backs the edit.html view.
 */
@ComponentManager.register()
export default class SiteEditor {
	public static componentStyleClass = "siteEditor";
	
	private expectedIFrameUrlOrigin: string | undefined;

	constructor(
		private readonly rootElement: HTMLElement,
		private readonly eventListenerManager = new EventListenerManager()
	) {
		eventListenerManager.manage(window).addEventListener("message", this.onMessage);
		eventListenerManager.manage(document).addEventListener("cms.variationSelectorChange", this.onVariationChange);
		eventListenerManager.manage(JsfAjax.getInstance()).addEventListener("success", this.onJsfAjaxEvent);

		CmsInterface.getInstance().set("siteEditor", this); // There should only ever be one. If there are multiple, the most recent will only be accessible.
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		CmsInterface.getInstance().delete("siteEditor");
		this.eventListenerManager.removeListeners();
	}

	loadUrl(url: string, force?: boolean) {
		const urlUtil = UrlUtil.getInstance(window);
		url = urlUtil.applyBaseUrl(url);
		this.expectedIFrameUrlOrigin = (new URL(url)).origin;
		const siteViewerIFrame = this.getSiteViewerIFrame();
		if (siteViewerIFrame.src !== url) {
			siteViewerIFrame.src = url;
		} else if (force === true) {
			siteViewerIFrame.contentWindow!.location.reload();
		}
	}

	reloadIFrame() {
		this.getSiteViewerIFrame().contentWindow!.location.reload();
	}

	private getSiteViewerIFrame(): HTMLIFrameElement {
		return this.rootElement.querySelector(".siteEditor__iframe") as HTMLIFrameElement;
	}

	private readonly onVariationChange = (ev: Event) => {
		const variationSelector = (ev.target instanceof HTMLSelectElement ? ev.target : this.rootElement.querySelector(".siteEditor__variationSelect")) as HTMLSelectElement;

		const url = new URL(this.getSiteViewerIFrame().src);
		const params = url.searchParams;
		const locale = variationSelector.value;
		params.set("locale", locale === 'Default' ? '' : locale);

		// Note: Did not include username and password, because if it was in the URL we should not keep submitting a login... especially in an insecure manner.
		this.loadUrl(url.origin + url.pathname +  "?" + params.toString() + url.hash);
	}

	private readonly onMessage = (ev: MessageEvent) => {
		if (ev.origin === this.expectedIFrameUrlOrigin && ev.data.type === "cms.pageChange") {
			JsfJsCommand.run("handlePageChange", this.rootElement, {
				params : ev.data
			});
		}
	}

	private readonly onJsfAjaxEvent = () => {
		let variationSelectors = document.querySelectorAll(".siteEditor__variationSelect[data-rendered-value]");
		for (let i = 0; i < variationSelectors.length; i++) {
			const variationSelector = variationSelectors.item(i) as HTMLSelectElement;

			const variationSelectorValue = variationSelector.getAttribute("data-siteEditor-rendered-value");

			const switchToDraft = variationSelectorValue !== null && variationSelectorValue.indexOf("x-draft") > -1;
			for (let j = 1; j < variationSelector.options.length; j++) { //First index is 1 because we never change the "Default" option
				const option = variationSelector.options[j]!;
				if ((option.value === "x-draft" || option.value.indexOf("x-draft") > -1) !== switchToDraft) {
					option.value =
						switchToDraft
							? option.value !== "" ? option.value + "-x-draft" : "x-draft"
							: option.value !== "x-draft" ? option.value.substring(0, option.value.indexOf("-x-draft")) : "";
				}
				if (option.selected !== (option.value === variationSelectorValue)) {
					option.selected = !option.selected;
				}
			}
			variationSelector.removeAttribute("data-siteEditor-rendered-value");
		}
	}
}
